'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Skills;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Skill = require('./Skill');

var _Skill2 = _interopRequireDefault(_Skill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'skills';

var getUserSkills = function getUserSkills(skills) {
  return skills.filter(function (skill) {
    return skill.selected;
  });
};

function Skills(_ref) {
  var skills = _ref.skills;

  return _react2.default.createElement(
    'div',
    {
      className: CLASS_NAME
    },
    _react2.default.createElement(
      'p',
      null,
      getUserSkills(skills).length,
      ' of ',
      skills.length,
      ' Matching Skills'
    ),
    _react2.default.createElement(
      'ul',
      { className: 'checkboxes' },
      skills.map(function (_ref2, key) {
        var id = _ref2.id,
            label = _ref2.label,
            selected = _ref2.selected;
        return _react2.default.createElement(_Skill2.default, {
          key: key,
          selected: selected,
          label: label
        });
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/Content/Skills/Skills.jsx
// module id = 1196
// module chunks = 0